  <app-question-form
    title="Ask me a question"
    [initialMessage]="(lastAskedQuestionsService.singleQuestionResponse$ | async)?.message"
    [isFetching]="isFetching"
    [response]="(lastAskedQuestionsService.singleQuestionResponse$ | async)?.response"
    [feedbackValue]="feedbackValue"
    (onSubmit)="handleMessageSubmit($event)"
    (onFeedback)="handleFeedbackSubmit($event)"
  ></app-question-form>
